import { ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import { useSearchParams } from 'react-router-dom';

import { useCurrentRole } from '../../../../../../hooks/useCurrentRole';
import { TableSection } from '../styles';
import { AnalysisQueues, visibleQueueTabs } from './components/AnalysisQueues';
import { OperationFlow } from './components/OperationFlow';
import { RequestList } from './components/RequestList';
import { RequestView } from './types';

export function NoticeDetailsRequest(): JSX.Element {
  const role = useCurrentRole();
  // The queue endpoints answer 403 outside the axis roles, so the whole view
  // is hidden when no queue is visible (PROT-2950). Visibility derives from
  // the same QUEUE_TABS the tabs render from — one registration point.
  const canSeeQueues = visibleQueueTabs(role).length > 0;

  // View (list/flow/queues) lives in the URL to survive returning.
  const [searchParams, setSearchParams] = useSearchParams();
  const viewParam = searchParams.get('view');
  let view: RequestView = 'list';
  if (viewParam === 'operation-flow') view = 'operation-flow';
  if (viewParam === 'analysis-queues' && canSeeQueues) {
    view = 'analysis-queues';
  }

  const handleViewChange = (
    event: React.MouseEvent<HTMLElement>,
    newView: RequestView | null
  ): void => {
    if (!newView) return;
    // Each view has its own list, page, search and queue.
    setSearchParams((prev) => {
      const next = new URLSearchParams(prev);
      next.set('view', newView);
      next.delete('page');
      next.delete('search');
      next.delete('queue');
      return next;
    });
  };

  const renderView = (): JSX.Element => {
    if (view === 'operation-flow') return <OperationFlow />;
    if (view === 'analysis-queues') return <AnalysisQueues />;
    return <RequestList />;
  };

  return (
    <TableSection>
      <Typography color="common.grey" fontSize={21} fontWeight={600} my={3}>
        Pedidos de credenciamento
      </Typography>
      <ToggleButtonGroup
        value={view}
        exclusive
        onChange={handleViewChange}
        size="small"
        color="secondary"
        sx={{ mb: 2 }}
      >
        <ToggleButton value="list" sx={{ textTransform: 'none' }}>
          Lista
        </ToggleButton>
        <ToggleButton value="operation-flow" sx={{ textTransform: 'none' }}>
          Fluxo de Operação
        </ToggleButton>
        {canSeeQueues && (
          <ToggleButton value="analysis-queues" sx={{ textTransform: 'none' }}>
            Filas de análise
          </ToggleButton>
        )}
      </ToggleButtonGroup>
      {renderView()}
    </TableSection>
  );
}
